import { useState } from "react";

export function useClientInfo() {
    const getClientInfo = () => {
        var I = {
            timeOpened: new Date(),
            timezone: (new Date()).getTimezoneOffset() / 60,

            pageon: window.location.pathname,
            referrer: document.referrer,

            platform: navigator.platform,
            browserName: navigator.appName,
            browserEngine: navigator.product,
            browserVersion1a: navigator.appVersion,
            browserVersion1b: navigator.userAgent,
            browserLanguage: navigator.language,
            browserOnline: navigator.onLine,
            browserPlatform: navigator.platform,
            dataCookiesEnabled: navigator.cookieEnabled,

            sizeDocW: document.width,
            sizeDocH: document.height,
        };
        return I
    }

	return {getClientInfo};
}